export default {
  id: 'leave',
  title: 'Leave',
  category: 'Employee',
  summary: 'View leave balances, accrual rates, and usage history by leave type and year.',
  overview: 'The Leave page shows how much leave you have available and how it was accrued or used. Leave taken on your timesheet feeds into these balances when leave tracking is enabled for your company.',
  howItWorks: [
    'Balances are shown by leave type (for example PTO or holiday) using tabs.',
    'Year selectors let you review historical accrual and usage.',
    'Initial balance, prior-year carryover, annual benefit, accrual rate, and year-to-date taken are calculated from company leave rules and your timesheet entries.',
    'Adjustments may appear when an administrator corrects a balance.'
  ],
  actions: [
    {
      name: 'Select leave type tab',
      description: 'Switches the stats and history to that leave category.'
    },
    {
      name: 'Change year',
      description: 'Reloads balances and history for the selected calendar year.'
    },
    {
      name: 'View usage history',
      description: 'Shows leave taken or adjusted over the selected period so you can reconcile against your timesheet.'
    }
  ],
  tips: [
    'Leave is usually recorded by charging leave charge codes on your timesheet — this page is primarily for viewing balances.',
    'If a balance looks wrong, contact your administrator before submitting related timesheets.'
  ],
  related: ['timesheet', 'profile']
};



// WEBPACK FOOTER //
// ./client/help/content/leave.js